<template>
  <div class="search">
    <form class="search__form">
      <input type="text" class="search__form__input" placeholder="Product search" v-model="search.searchString">
      <select class="select select--stick search__form__select" v-model="search.fileTypeId">
        <option :value="term.Value" v-for="term in searchTerms">{{term.Text}}</option>
      </select>
      <button type="submit" class="button login__form__button" v-link="'/search/' + search.fileTypeId + '/' + search.searchString">{{getResource('Search')}}</button>
    </form>
  </div>
</template>

<script>
import { getResource } from "../../vuex/helpers";

export default {
  vuex: {
    getters: {
      searchTerms: state => state.searchTerms
    },
    actions: { getResource }
  },
  data () {
    return {
      search: {
        fileTypeId: -1,
        searchString: ""
      }
    };
  }
};
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/elements/button.scss';
  @import '../../assets/scss/elements/input.scss';
  @import '../../assets/scss/elements/select.scss';

  .search{
    &__form{
      background: $green_light;
      text-align: center;
      padding: 30px;
      box-sizing: border-box;
      border-bottom: 1px solid #fff;

      &__input{
        @extend .input;
        width: 275px;
      }

      &__select{
        width: 175px;
        margin: 0 10px 0 -10px;
      }

      a{
        color: $white;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// HomeSearch.vue?43d319ae